import { type GetServerSidePropsContext } from "next"
import { OnboardingMeterDetailsPage } from "@/features/onboarding/components/OnboardingMeterDetailsPage"
import { getOnboardingServerSideProps } from "@/features/onboarding/utils/getOnboardingServerSideProps"
import { createOnboardingQueryParamsSchema } from "@/features/onboarding/utils/onboardingQueryParams"
import { OnboardingRouteNames } from "@/routes/onboarding"

export default OnboardingMeterDetailsPage

export const QueryParamsSchema = createOnboardingQueryParamsSchema()

export async function getServerSideProps(context: GetServerSidePropsContext) {
    const parsedQueryParams = QueryParamsSchema.safeParse(context.query)

    if (!parsedQueryParams.success) {
        return { notFound: true }
    }

    return getOnboardingServerSideProps({
        queryParams: parsedQueryParams.data,
        context,
        intlNamespaces: OnboardingMeterDetailsPage.messages,
        options: {
            subscriptionTypesToReset: ["CHECKOUT_PAGES", "CROSS_SALE", "EMAIL_QUOTE", "MOVE_OUT"],
        },
        stepName: OnboardingRouteNames.MeterDetails,
    })
}
